<template>
    <div class="template template--basic">

        <div class="login">
            <header class="login__header">
                <h1>Reset je wachtwoord</h1>
                <p>Voer de onderstaande velden in om je wachtwoord te veranderen.</p>
            </header>

            <div class="login__panel-wrap">
                <div class="login__panel">

                    <form class="login__form">

                        <input type="hidden" name="token" :value="token">

                        <div class="input-group" :class="{ error : containsError('email')}">
                            <label for="email">E-mail</label>
                            <input type="email" name="email" id="email" v-model="email" @keydown.enter.prevent="submit" :autofocus="!isTouch" />
                        </div>

                        <div class="input-group" :class="{ error : containsError('password')}">
                            <label for="password">Wachtwoord</label>
                            <input type="password" name="password" id="password" v-model="password" @keyup.enter.prevent="submit" />
                        </div>

                        <div class="input-group" :class="{ error : containsError('passwordConfirmation')}">
                            <label for="passwordConfirmation">Herhaal wachtwoord</label>
                            <input type="password" name="passwordConfirmation" id="passwordConfirmation" v-model="passwordConfirmation" @keyup.enter.prevent="submit" />
                        </div>

                        <primary-button @clicked="submit" :loading="loading" >Verstuur</primary-button>

                    </form>
                    
                </div>

                <div class="login__auth-other">
                    <router-link :to="{ name: 'login' }" class="to-login" >Terug naar inloggen</router-link>
                </div>

            </div>

        </div>
    </div>
</template>


<script>
import api from 'js/api/resources';
import notify from 'js/components/notifications/notificationsMixin';
import validation from 'js/components/auth/validationMixin';
import touch from 'js/components/auth/touchMixin';

import { login } from 'js/api/auth';

import PrimaryButton from 'js/components/elements/PrimaryButton.vue';

export default {
    name: 'ResetPassword',
    mixins: [ notify, validation, touch ],
    components: { PrimaryButton },
    props: [],
    data: function() {
        return {
            email: '',
            password: '',
            passwordConfirmation: '',
            loading: false,
            errors: [],
            errorFields: [],
        }
    },
    computed: {
        token: function() {
            return this.$route.params.resetToken
        }
    },
    methods: {
        submit: function(e) {

            e.preventDefault();

            if ( this.validate() ) {

                this.loading = true

                api.resetPassword(this.token, this.email, this.password, this.passwordConfirmation)
                    .then( () =>

                        login(this.email, this.password)
                            .then( () => {
                                this.$success('Je wachtwoord is aangepast.', { id: 'validation' })
                                this.$router.push({ name: 'root' })
                            })

                    )
                    .catch( response => this.handleErrorResponse(response, 'Wachtwoord reset is mislukt.'))
                        .then( () => this.loading = false)

            }

        },
        validateFields: function() {
            this.validateEmail(this.email)
            this.validatePasswordLength(this.password)
            this.validatePasswordEqual(this.password, this.passwordConfirmation)
        }

    }

}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// ResetPassword.vue?deb5fabe